 
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirebaseApp } from "../../config/firebase/firebaseClient";
 
const functions = getFunctions(getFirebaseApp());  

 
export const callGetLedgerRecords = async (data) => {
  try {
    const getLedgerRecords = httpsCallable(functions, "getLedgerRecords");
    const result = await getLedgerRecords(data);
    return result.data;
  } catch (error) {
    console.error("Error calling getLedgerRecords function:", error);
    throw error;
  }
};


 
export const callExportLedgerToCSV = async (data) => {
  try {
    const exportLedgerCSV = httpsCallable(functions, "exportLedgerCSV");
    const result = await exportLedgerCSV(data);
    return result.data;
  } catch (error) {
    console.error("Error calling exportLedgerCSV function:", error);
    throw error;
  }
};